import React from "react";
import RequestCallBack from "components/education-finance/hero-section/request-call-back";
import { AppContainer } from "container/app-container";
import { NonDashboardWrapper } from "container/non-dashboard-wrapper";
import { FinanceContainer, FinanceFormContainer } from "styles/admin/adverts/adverts.style";

const FinanceLoanApplication = () => {
   return (
      <NonDashboardWrapper>
         <AppContainer
            title="Get quick loan for your child’s school fees"
            description="We provide access to quick tuition loan in Nigeria with ease. No collateral or paperwork is required. Fill this simple form now to borrow money to pay your child’s school fees."
         >
            <FinanceContainer>
               <FinanceFormContainer>
                  <RequestCallBack />
               </FinanceFormContainer>
            </FinanceContainer>
         </AppContainer>
      </NonDashboardWrapper>
   );
};

export default FinanceLoanApplication;
